import React, {useState} from 'react';

import {Input, List} from "antd";
import useSearch from "../../hooks/useSearch";
import {Scrollbars} from "react-custom-scrollbars";

export default function Tenant({apiEndPoint, onSelect, onChange}) {

	const { loading, results, debouncedSearch } = useSearch(apiEndPoint, 200);
	const [mail, setMail] = useState("");
	const [item, setItem] = useState(null);
	const [displayResults, setDisplayResults] = useState(false);

	const handleSelect = (item) => {
		//console.log('select');
		onSelect(item);
		setItem(item);
		setMail(item.email1 || item.email2 || '');
		setDisplayResults(false);

	}

	const handleSearch = async (value) => {
		// Réinitialiser la sélection lors de la saisie manuelle
		setItem(null);

		setDisplayResults(true);
		setMail(value);

		if (onChange) {
			onChange(value);
		}

		await debouncedSearch(value);
	}

	const handleBlur = () => {
		//console.log('blur', mail);
		setTimeout(() => {
			setDisplayResults(false);
		}, 150);
	}

	const handleFocus = (e) => {
		e.target.select();

		// Si un client existant est sélectionné, afficher uniquement ce client
		if (item && e.target.value !== '') {
			setDisplayResults(true);
			// Ne PAS relancer la recherche, juste afficher le client sélectionné
		} else if (e.target.value !== '') {
			// Si c'est une saisie manuelle, relancer la recherche
			setDisplayResults(true);
			handleSearch(e.target.value).then();
		}
	}

	return (
		<>
				<Input
					value={mail}
					onFocus={handleFocus}
					autoComplete="new-password"
					//onBlur={() => setDisplayResults(false)} // A utiliser avec onMouseDown
					//onBlur={() => setTimeout(() => setDisplayResults(false), 150)} // obligé avec onClick
					onBlur={handleBlur}
					onChange={(e) => handleSearch(e.target.value)}
				/>
				{ displayResults &&
					<div style={{
						marginTop: -5,
						border: '1px solid #8C8C8C',
						borderRadius: '5px',
						boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)'
					}}>
					<Scrollbars
						autoHide
						autoHeight
						autoHeightMax={300}
						//renderThumbVertical={() => <div style={{ display: 'none' }} />}
					>
					<List
					header={false}
					footer={false}
					loading={loading}
					size="small"
					bordered={false}
					itemLayout="horizontal"
					dataSource={item ? [item] : results}
					renderItem={listItem =>
						<List.Item
							key={listItem.id}
							style={{
								cursor: 'pointer',
								transition: 'background-color 0.3s ease'
							}}
							onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
							onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
							//onMouseDown={() => handleSelect(item)}
							onClick={() => handleSelect(listItem)}
						>
							<div>
								<div style={{fontWeight: 500}}>
									{listItem.email1 || listItem.email2 || 'pas d\'email'}
								</div>
								<div style={{fontSize: '12px', color: '#888'}}>
									{listItem.fullname} ({listItem.code || 'N/A'})
								</div>
								<div style={{fontSize: '12px', color: '#888'}}>
									{listItem.address || 'pas d\'adresse'}
								</div>
							</div>
						</List.Item>
					}
				/>
					</Scrollbars>
					</div>
					}
		</>
	);
}
